import {
    createContext,
    Dispatch,
    FC,
    PropsWithChildren,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react'
import { ChatClient, ChatClientProvider, LogLevel, Message } from '@ably/chat'
import * as Ably from 'ably'
import Push from 'ably/push'
import { AblyProvider } from 'ably/react'

const realtimeClient = new Ably.Realtime({
    pushServiceWorkerUrl: '/service-worker.js',
    plugins: { Push },
    logLevel: 0,
    logHandler: (msg) => {
        console.log(msg)
    },
    authUrl: '/api/ably/token',
    closeOnUnload: true,
    autoConnect: typeof window !== 'undefined',
})

const chatClient = new ChatClient(realtimeClient, { logLevel: LogLevel.Warn })

type AblyContextType = {
    showChat: boolean
    showNewMessageBadge: boolean
    setShowChat: Dispatch<SetStateAction<boolean>>
    setShowNewMessageBadge: Dispatch<SetStateAction<boolean>>
    messages: Message[]
    setMessages: Dispatch<SetStateAction<Message[]>>
}

const AblyContext = createContext<AblyContextType>({} as AblyContextType)

type AblyContextProviderProps = object

export const AblyContextProvider: FC<PropsWithChildren<AblyContextProviderProps>> = ({ children }) => {
    const [showChat, setShowChat] = useState(false)
    const [showNewMessageBadge, setShowNewMessageBadge] = useState(false)
    const [messages, setMessages] = useState<Message[]>([])

    useEffect(() => {
        if (showChat) {
            setShowNewMessageBadge(false)
        }
    }, [showChat])

    return (
        <AblyContext.Provider
            value={{
                setShowChat,
                setShowNewMessageBadge,
                showChat,
                showNewMessageBadge,
                messages,
                setMessages,
            }}
        >
            <AblyProvider client={realtimeClient}>
                <ChatClientProvider client={chatClient}>{children}</ChatClientProvider>
            </AblyProvider>
        </AblyContext.Provider>
    )
}

export const useAblyContext = () => {
    return useContext(AblyContext)
}
